import React from 'react';
import { motion } from 'framer-motion';
import mapImage from '../assets/images/Map/mapa.png';

const Location = () => {
  const openingHours = [
    { day: 'Lunes', hours: '12:00 - 22:00' },
    { day: 'Martes', hours: '12:00 - 22:00' },
    { day: 'Miércoles', hours: '12:00 - 22:00' },
    { day: 'Jueves', hours: '12:00 - 23:00' },
    { day: 'Viernes', hours: '12:00 - 00:00' },
    { day: 'Sábado', hours: '11:00 - 00:00' },
    { day: 'Domingo', hours: '11:00 - 22:00' },
  ];

  return (
    <section id="location" className="py-20 bg-marina-50 relative">
      <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-white to-marina-50"></div>
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-marina-50"></div>
      
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="section-title inline-block">Ubicación y Horarios</h2>
          <p className="text-lg text-gray-600 mt-6 max-w-2xl mx-auto">
            Estamos ubicados en un lugar privilegiado con vista al mar. Visítanos y disfruta de la mejor experiencia gastronómica.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Map Section */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="overflow-hidden rounded-xl shadow-lg"
          >
            <div className="h-96 relative overflow-hidden rounded-xl">
              <img 
                src={mapImage} 
                alt="Mapa de ubicación de La Barra Brava" 
                className="w-full h-full object-cover object-center"
                style={{ objectPosition: "50% 50%" }}
              />
            </div>
          </motion.div>

          {/* Info Section */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="card p-8 h-full">
              <div className="mb-8">
                <h3 className="text-xl font-bold text-marina-800 mb-4">Dirección</h3>
                <p className="text-gray-700">
                  <i className="fas fa-map-marker-alt text-marina-600 mr-3"></i>
                  Avenida del Mar 1256, Viña del Mar, Chile
                </p>
                <p className="text-gray-600 mt-2 ml-7">
                  A pasos de la Caleta Abarca, junto al Muelle Principal
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-xl font-bold text-marina-800 mb-4">Horarios de Atención</h3>
                <div className="space-y-2">
                  {openingHours.map((item, index) => (
                    <div key={index} className="flex justify-between items-center">
                      <span className="font-medium text-gray-700">{item.day}</span>
                      <span className="text-gray-600">{item.hours}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-xl font-bold text-marina-800 mb-4">Contacto</h3>
                <div className="space-y-3">
                  <p className="text-gray-700">
                    <i className="fas fa-phone text-marina-600 mr-3"></i>
                    +56 9 8765 4321
                  </p>
                  <p className="text-gray-700">
                    <i className="fas fa-envelope text-marina-600 mr-3"></i>
                    reservas@labarrabrava.cl
                  </p>
                  <div className="flex space-x-4 mt-4">
                    <a 
                      href="https://www.facebook.com/profile.php?id=61565513198161" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-marina-600 hover:text-marina-800 transition-colors duration-300"
                      aria-label="Siguenos en Facebook"
                    >
                      <i className="fab fa-facebook-f text-xl"></i>
                    </a>
                    <a 
                      href="https://www.instagram.com/labarrabravarestaurante/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-marina-600 hover:text-marina-800 transition-colors duration-300"
                      aria-label="Siguenos en Instagram"
                    >
                      <i className="fab fa-instagram text-xl"></i>
                    </a>
                    <a 
                      href="#" 
                      className="text-marina-600 hover:text-marina-800 transition-colors duration-300"
                      aria-label="Siguenos en TripAdvisor"
                    >
                      <i className="fab fa-tripadvisor text-xl"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Location;
